import { Box } from '@mui/material';
import { KitItem, KitList, KitPill } from './MobileKit';
import { protoIcon } from './ProtoIcon';
import { KitSearch } from './MobileKitExtras';

/**
 * Campo único "Produto ou serviço" das folhas "Adicionar item" (OS e orçamento, mobile).
 * A busca (debounce + endpoint `searchitem`) fica na tela dona; aqui só se apresenta e
 * ordena o resultado unificado, com a pílula do tipo em cada linha.
 */

const WrenchIcon = protoIcon('wrench');
const PackageIcon = protoIcon('package');
const CheckIcon = protoIcon('check');

// Nome que começa com o termo vem primeiro; depois os que contêm; mantém a ordem original no empate.
export function rankItemResults(items, term) {
    const q = String(term || '').trim().toLowerCase();
    const score = (item) => {
        const name = String(item.name || '').toLowerCase();
        if (name.startsWith(q)) return 0;
        if (name.includes(q)) return 1;
        return 2;
    };
    return (items || [])
        .map((item, index) => ({ item, index, rank: score(item) }))
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .map((entry) => entry.item);
}

export default function MobileItemSearch({ term, onTermChange, results, picked, onPick }) {
    const hasTerm = Boolean(term.trim());
    const list = hasTerm ? rankItemResults(results, term) : [];
    const isPicked = (item) => picked?.id === item.id && picked?.type === item.type;

    return (
        <>
            <KitSearch
                value={term}
                onChange={(e) => onTermChange(e.target.value)}
                placeholder="Produto ou serviço"
                inputProps={{ 'aria-label': 'Produto ou serviço' }}
            />
            <Box sx={{ mt: '12px' }}>
                {list.length === 0 ? (
                    <Box sx={{ textAlign: 'center', p: '20px', fontSize: 13, color: 'text.disabled' }}>
                        {hasTerm ? 'Nenhum produto ou serviço encontrado' : 'Digite para buscar produtos ou serviços'}
                    </Box>
                ) : (
                    <KitList>
                        {list.map((item) => (
                            <KitItem
                                key={`${item.type}-${item.id}`}
                                icon={item.type === 'service' ? WrenchIcon : PackageIcon}
                                title={item.name}
                                sub={item.value !== undefined ? `R$ ${item.value}` : undefined}
                                sx={isPicked(item) ? { backgroundColor: 'info.bg' } : undefined}
                                end={(
                                    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                        <KitPill tone={item.type === 'service' ? 'purple' : 'info'}>
                                            {item.type === 'service' ? 'Serviço' : 'Produto'}
                                        </KitPill>
                                        {isPicked(item) && <Box sx={{ color: 'primary.main', display: 'inline-flex' }}><CheckIcon size={20} /></Box>}
                                    </Box>
                                )}
                                onClick={() => onPick(item)}
                            />
                        ))}
                    </KitList>
                )}
            </Box>
        </>
    );
}
